<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="查看详情"></el-page-header>
        <el-form label-position="right" :model="item" label-width="auto">
            <!--            有id时候 静态页面数据-->
            <el-form-item label="编号" v-if="id">
                <el-input value="2021070110110714"></el-input>
            </el-form-item>

            <el-form-item label="单价" v-if="id">
                <el-input value="100.00"></el-input>
            </el-form-item>

            <el-form-item label="数量" v-if="id">
                <el-input value="1"></el-input>
            </el-form-item>

            <el-form-item label="金额" v-if="id">
                <el-input value="1000.00"></el-input>
            </el-form-item>


            <el-form-item label="会员" v-if="id">
                <el-input value="oBZ8p5-7CqGeTfw1PcmlHML4vjeA"></el-input>
            </el-form-item>

            <el-form-item label="支付渠道" v-if="id">
                <el-input value="支付宝"></el-input>
            </el-form-item>
            <el-form-item label="支付状态" v-if="id">
                <el-input value="已支付"></el-input>
            </el-form-item>
            <el-form-item label="订单状态" v-if="id">
                <el-input value="已取消"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                item:{},
                isLoad:false,
                id:this.$route.query.id,
                logo:[],
                options: []
            }
        },
        created(){
            // this.loadData()
        },
        methods:{
            loadData: function() {
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/list',{
                }).then(res => {
                    res.data.records.forEach((item)=>{
                        this.options.push(item)
                    })
                }).then(res => {
                    if(this.id) {
                        return this.axios.post('/store/detail', {
                            id: this.id
                        })
                    }
                }).then(res => {
                    this.isLoad = !this.isLoad
                    if(res){
                        // item是基础信息
                        this.item = res.data
                        // 当图片存在的时候
                        if (this.item.logo) {
                            this.logo = [{
                                name: this.item.logo,
                                url: this.item.logo,
                                response: {
                                    data: {
                                        src: this.item.logo
                                    }
                                }
                            }]
                        }
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack(){
                this.$router.back(-1)
            },
            // 提交
            submit(){
                return;
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                if(this.logo){
                    this.item.logo = this.logo[0].response.data.src
                }
                let url = ''
                if(this.id){
                    url = '/store/update'
                    this.item.id = this.id
                }else{
                    url = '/store/add'
                }
                console.log(this.item);
                this.axios.post(url,this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadError(){
                this.$message.error({
                    message: '上传失败'
                });
            },
            uploadSuccess(res,file){
                file.name = res.data.src
                this.logo = [file]
                this.$message.success({
                    message: '上传成功'
                });
            },
            uploadRemove:function() {
                this.logo = []
            }
        }
    }
</script>
<style scoped>
</style>